<template>
  <!--
    KAN-58：Gastric varices（胃靜脈曲張）Form 欄位——各級別（F1/F2/F3）可填數量。
    取代原單選 radio。值以編碼字串（F1:2;F2:1）透過 @change 上拋，存入 records.form。
  -->
  <div class="form-quantity">
    <div
      v-for="level in levels"
      :key="level"
      class="form-quantity__item"
      :title="$t('finding_words.form_quantity_unit')"
    >
      <label class="form-quantity__label">{{ level }}</label>
      <v-text-field
        class="form-quantity__field"
        type="number"
        min="0"
        hide-details
        single-line
        outline
        :placeholder="$t('finding_words.form_quantity_unit')"
        :value="quantities[level]"
        @input="onInput(level, $event)"
      />
    </div>
  </div>
</template>

<script>
import {
  FORM_LEVELS,
  parseToQuantities,
  buildEncoded,
} from "@/utils/form-quantity";

export default {
  name: "FormQuantityInput",
  props: {
    // records.form 目前值：新編碼("F1:2;F2:1")、舊 option id("260") 或空字串
    value: {
      type: [String, Number],
      default: "",
    },
    // i18n 轉換函式（與同層其他 record 欄位元件一致，供未來標籤在地化）
    transI18n: {
      type: Function,
      required: false,
      default: (k) => k,
    },
  },
  data() {
    return {
      levels: FORM_LEVELS,
      // 三級別當前數量，空字串代表未填
      quantities: parseToQuantities(this.value),
    };
  },
  watch: {
    // 外部值變動（載入既有紀錄 / 切換 record）時重新解析，含舊 option id 向下相容
    value(newVal) {
      this.quantities = parseToQuantities(newVal);
    },
  },
  methods: {
    onInput(level, val) {
      // 只接受非負整數；空字串＝清除該級別
      if (val === "" || val === null) {
        this.quantities[level] = "";
      } else {
        const n = parseInt(val, 10);
        this.quantities[level] = Number.isInteger(n) && n >= 0 ? n : "";
      }
      // 上拋整份編碼（只含 qty>=1 的級別；全空回空字串→等同清除）
      this.$emit("change", buildEncoded(this.quantities));
    },
  },
};
</script>

<style lang="scss" scoped>
.form-quantity {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  &__item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  &__label {
    font-weight: 600;
    min-width: 28px;
  }
  &__field {
    width: 72px;
    margin: 0;
    padding: 0;
  }
}
</style>
